import React from "react";
import { ChevronRight, Star } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { IMAGES } from "../mock";
import { Button } from "./ui/button";

export default function Hero() {
  const { t, S } = useLang();
  return (
    <section id="top" className="relative min-h-[100svh] flex items-center overflow-hidden">
      <img
        src={IMAGES.heroBeach}
        alt="Cancún beach"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8 w-full pt-28 pb-16">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-white/90 text-sm font-semibold tracking-wide bg-white/15 backdrop-blur px-4 py-1.5 rounded-full border border-white/25">
            <Star className="w-4 h-4 text-accent fill-accent" />
            {t(S.hero.kicker)}
          </span>

          <h1 className="mt-6 font-display font-extrabold text-white text-4xl sm:text-5xl md:text-6xl leading-[1.05]">
            {t(S.hero.title)}
          </h1>

          <p className="mt-6 text-white/90 text-lg md:text-xl max-w-2xl leading-relaxed">
            {t(S.hero.subtitle)}
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <Button
              asChild
              size="lg"
              className="bg-accent hover:bg-accent/90 text-accent-foreground font-semibold rounded-full px-7 h-13 text-base group"
            >
              <a href="#reservar">
                {t(S.hero.ctaBook)}
                <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="rounded-full px-7 h-13 text-base bg-white/10 backdrop-blur border-white/40 text-white hover:bg-white/20 hover:text-white"
            >
              <a href="#tarifas">{t(S.hero.ctaRates)}</a>
            </Button>
          </div>

          <div className="mt-14 flex flex-wrap gap-10">
            {[
              { big: "24/7", label: t(S.hero.stat1) },
              { big: "5,000+", label: t(S.hero.stat2) },
              { big: "ES · EN", label: t(S.hero.stat3) },
            ].map((s) => (
              <div key={s.label}>
                <div className="font-display font-extrabold text-white text-3xl md:text-4xl">{s.big}</div>
                <div className="text-white/80 text-sm mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
